import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline';
import logoSrc from '@/assets/landing/logo_migro.png';

export function AbogadosFooter() {
  return (
    <footer id="contacto" className="border-t border-white/10 bg-black py-12">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Brand */}
          <div>
            <img src={logoSrc} alt="Migro" className="h-8 brightness-0 invert" />
            <p className="mt-2 text-sm text-slate-400">
              Plataforma tecnológica de distribución de demanda cualificada
              para abogados de inmigración.
            </p>
            <p className="mt-4 rounded-lg bg-white/[0.05] p-3 text-xs text-slate-500">
              Migro es una plataforma tecnológica. Los servicios legales son prestados por
              abogados colegiados independientes.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="mb-3 text-sm font-semibold text-white">Legal</p>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <a href="/privacidad" className="transition hover:text-white">
                  Política de privacidad
                </a>
              </li>
              <li>
                <a href="#" className="transition hover:text-white">
                  Términos para abogados
                </a>
              </li>
              <li>
                <a href="#" className="transition hover:text-white">
                  Aviso legal
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="mb-3 text-sm font-semibold text-white">Contacto equipo comercial</p>
            <ul className="space-y-2 text-sm text-slate-400">
              <li className="flex items-center gap-2">
                <EnvelopeIcon className="h-4 w-4 text-slate-500" />
                <a href="mailto:abogados@migro.es" className="transition hover:text-white">
                  abogados@migro.es
                </a>
              </li>
              <li className="flex items-center gap-2">
                <PhoneIcon className="h-4 w-4 text-slate-500" />
                <a href="tel:+34900000000" className="transition hover:text-white">
                  900 000 000
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} Migro Servicios y Remesas SL. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>
  );
}
